module.exports = __webpack_public_path__ + "static/cake-branding-816498bf887d4bd12a442ef99bd97049.svg";